import buttonTextImg from './texts/button_text.png';
import type { DeliveryPopupChromeLayout } from './deliveryPopupLayout';
import './TakeDeliveryButton.css';

export type TakeDeliveryButtonProps = {
  onClick?: () => void;
  layout: DeliveryPopupChromeLayout['takeDeliveryButton'];
};

/** Figma take_delivery_button (180:104) — compact map popup CTA. */
export function TakeDeliveryButton({
  onClick,
  layout,
}: TakeDeliveryButtonProps) {
  return (
    <button
      type="button"
      className="take-delivery-button"
      aria-label="Взять заказ"
      onClick={onClick}
      style={{
        left: layout.left,
        top: layout.top,
        width: layout.width,
        height: layout.height,
        ['--take-btn-text-width' as string]: `${layout.textWidth}px`,
        ['--take-btn-text-height' as string]: `${layout.textHeight}px`,
      }}
    >
      <img
        className="take-delivery-button__text"
        src={buttonTextImg}
        alt=""
        draggable={false}
      />
    </button>
  );
}
